import type { CSSProperties } from 'react';

export const projectsBoardStyle: CSSProperties = {
  width: 'max-content',
  backgroundColor: 'inherit',
  height: 'calc(100vh - 140px)',
  padding: '5px 0px',
  overflow: 'visible',
};

export const projectsLaneStyle: CSSProperties = {
  backgroundColor: 'var(--kanban-lane-bg, #ebecf0)',
  margin: '0px',
  marginLeft: '6px',
  position: 'relative',
  padding: '8px',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  boxShadow: '0px 2px 4px 0px rgba(99, 99, 99, 0.3), 0px -0px 4px 0px rgba(99, 99, 99, 0.3)',
  borderRadius: '8px',
};
